module.exports = __webpack_public_path__ + "static/media/loading_img.a132a9b2.gif";